import { render, staticRenderFns } from "./SingleSelectFilter.vue?vue&type=template&id=2c27b704&scoped=true&"
import script from "./SingleSelectFilter.vue?vue&type=script&lang=js&"
export * from "./SingleSelectFilter.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectFilter.vue?vue&type=style&index=0&id=2c27b704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27b704",
  null
  
)

export default component.exports